export default __webpack_public_path__ + "static/media/john.24d7e28a.png";